import React, { useState } from "react";
import { Input, Select, DatePicker, AutoComplete, TimePicker } from "antd";
import "./floatInput.css";
import {
  CloseCircleFilled,
  DownOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import CustomTimeRangePicker from "./CustomTimeRangePicker";

const FloatInput = (props) => {
  const { TextArea } = Input;
  const [focus, setFocus] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);

  let {
    label,
    value,
    placeholder,
    type,
    required,
    selectOptions,
    name,
    disabledDate,
    options,
    suffix,
    style,
    rows,
    maxLength,
    min,
    max,
    key,
    inputWidth,
    disabled,
    format,
    allowClear,
    optionFilterProp,
    onInputKeyDown,
    onKeyDown,
    onKeyUp,
    onFocus,
    textArea,
    autofocus,
    urduFont,
    customValidation,
  } = props;

  if (!placeholder) placeholder = label;

  const isOccupied = focus || (value && value.length !== 0);
  const labelClass = "label as-label";
  const requiredMark = required ? (
    <span className="text-danger" style={{ color: "red" }}>
      *
    </span>
  ) : null;

  const togglePasswordVisibility = () => setPasswordVisible(!passwordVisible);

  const urduFontStyle =
    urduFont || type === "urdu"
      ? {
          fontFamily: "'Noto Nastaliq Urdu', serif",
          fontSize: "10px",
          lineHeight: "1.6",
          ...props.style,
        }
      : props.style;

  return (
    <div
      className="float-label"
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
    >
      {type == "disnumber" && (
        <Input
          onChange={props.onChange}
          disabled={props.disabled}
          readOnly={true}
          suffix={suffix}
          type={type}
          max={props.max}
          value={value}
          min={props.min}
          maxLength={maxLength}
          placeholder={props.placeholder}
          style={{ width: inputWidth ? inputWidth : "" }}
        />
      )}

      {type == undefined && (
        <Input
          onChange={(e) => {
            const val = e.target.value;
            if (customValidation) {
              if (val === "" || customValidation(val)) {
                props.onChange(e);
              }
            } else {
              props.onChange(e);
            }
          }}
          onKeyDown={onKeyDown}
          allowClear={allowClear}
          suffix={suffix}
          name={name}
          style={props.style}
          type={type}
          defaultValue={value}
          value={value}
          max={props.max}
          min={props.min}
          maxLength={maxLength}
          disabled={props.disabled}
          showCount={props.showCount}
          addonBefore={props.addonBefore}
          id={props.id}
          dir={props?.dir}
          placeholder={props?.placeholder}
          autoComplete={
            name === "userName" ? "new-password" : props.autoComplete
          }
        />
      )}

      {type == "urdu" && (
        <Input
          onChange={props.onChange}
          suffix={suffix}
          name={name}
          style={{
            fontFamily: "'Noto Nastaliq Urdu', serif",
            fontSize: "10px",
            lineHeight: "1.8",
            direction: "rtl",
            textAlign: "right",
            ...props.style,
          }}
          type="text"
          defaultValue={value}
          value={value}
          max={props.max}
          min={props.min}
          maxLength={maxLength}
          disabled={props.disabled}
          showCount={props.showCount}
          addonBefore={props.addonBefore}
          id={props.id}
          dir={props?.dir}
          placeholder={props?.placeholder}
          autoFocus={props.autofocus}
          activeBorderColor="red"
        />
      )}

      {type == "number" && (
        <Input
          onChange={props.onChange}
          suffix={suffix}
          type={type}
          step={props.step}
          name={name}
          max={props.max}
          value={value}
          min={props.min}
          maxLength={maxLength}
          disabled={props.disabled}
          placeholder={props.placeholder}
          autoFocus={props.autofocus}
          style={{ width: inputWidth ? inputWidth : "" }}
          addonBefore={props.addonBefore}
          onPressEnter={props.onPressEnter}
          onKeyDown={props.onKeyDown}
          onFocus={onFocus}
          onWheel={(e) => e.target.blur()}
        />
      )}

      {type == "password" && (
        <>
          <input
            type="text"
            name="fakeUsername"
            autoComplete="username"
            style={{ display: "none" }}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
          />
          <input
            type="password"
            name="fakePassword"
            autoComplete="new-password"
            style={{ display: "none" }}
            readOnly
            tabIndex={-1}
            aria-hidden="true"
          />
          <Input
            type={passwordVisible ? "text" : "password"}
            onChange={(e) => props.onChange(e.currentTarget.value, name)}
            placeholder={props.placeholder}
            min={min}
            max={max}
            autoComplete="new-password"
            readOnly
            onFocus={(e) => e.target.removeAttribute("readonly")}
            suffix={
              <span
                onClick={togglePasswordVisibility}
                style={{ cursor: "pointer" }}
              >
                {passwordVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </span>
            }
            value={value}
            maxLength={maxLength}
          />
        </>
      )}

      {type == "select" && (
        <Select
          onChange={props.onChange}
          value={props.value}
          style={{ width: inputWidth ? inputWidth : "" }}
          dropdownStyle={props.dropdownStyle}
          disabled={props?.disabled}
          readOnly={props?.readOnly}
          loading={props?.isLoading}
          defaultValue={props.defaultValue}
          mode={props?.mode}
          filterOption={props?.filterOption}
          optionFilterProp={props?.optionFilterProp}
          size={props?.size}
          onSelect={props?.onSelect}
          allowClear={props?.allowClear}
          placeholder={props.placeholder}
          onFocus={onFocus}
        >
          {selectOptions}
        </Select>
      )}

      {type == "searchselect" && (
        <Select
          showSearch
          allowClear
          onChange={props.onChange}
          value={props.value}
          style={{ width: inputWidth ? inputWidth : "", ...style }}
          dropdownStyle={props.dropdownStyle}
          disabled={props?.disabled}
          readOnly={props?.readOnly}
          loading={props?.isLoading}
          defaultValue={props.defaultValue}
          mode={props?.mode}
          filterOption={
            props?.filterOption !== undefined
              ? props.filterOption
              : (input, option) =>
                  (option?.children ?? option?.label ?? "")
                    .toString()
                    .toLowerCase()
                    .includes(input.toLowerCase())
          }
          optionFilterProp={props?.optionFilterProp}
          size={props?.size}
          options={props?.options}
          onSelect={props?.onSelect}
          onInputKeyDown={props?.onInputKeyDown}
          onKeyDown={props?.onKeyDown}
          onKeyUp={props?.onKeyUp}
          onClear={props?.onClear}
          getPopupContainer={props?.getPopupContainer}
          removeIcon={props?.removeIcon}
          autoClearSearchValue={props?.autoClearSearchValue}
          placeholder={props.placeholder}
          autoFocus={props.autofocus}
          onFocus={onFocus}
          clearIcon={
            <CloseCircleFilled
              style={{ fontSize: "14px", color: "rebeccapurple" }}
            />
          }
        >
          {selectOptions}
        </Select>
      )}

      {type === "selectMultiple" && (
        <div className="custom-select-wrapper">
          <Select
            showArrow
            showSearch
            allowClear
            suffixIcon={<DownOutlined style={{ fontSize: 12 }} />}
            mode="tags"
            onChange={props.onChange}
            value={props.value}
            style={{ width: inputWidth ? inputWidth : "100%" }}
            dropdownStyle={{
              ...props.dropdownStyle,
              fontFamily: "'Noto Nastaliq Urdu', serif",
              direction: "rtl",
              textAlign: "right",
            }}
            tagRender={(props) => {
              const { label, value, closable, onClose } = props;
              return (
                <div
                  style={{
                    display: "inline-block",
                    height: "auto",
                    marginRight: "8px",
                    marginBottom: "2px",
                    padding: "0 7px",
                    fontSize: "10px",
                    lineHeight: "1.8",
                    whiteSpace: "nowrap",
                    background: "#f5f5f5",
                    border: "1px solid #d9d9d9",
                    borderRadius: "6px",
                    cursor: "default",
                    opacity: 1,
                    fontFamily: "'Noto Nastaliq Urdu', serif",
                    direction: "rtl",
                    textAlign: "right",
                  }}
                >
                  <span style={{ marginRight: closable ? "4px" : "0" }}>
                    {label}
                  </span>
                  {closable && (
                    <span
                      style={{
                        display: "inline-block",
                        color: "#999",
                        fontWeight: "bold",
                        fontSize: "12px",
                        lineHeight: "inherit",
                        cursor: "pointer",
                        marginLeft: "4px",
                      }}
                      onClick={onClose}
                    >
                      ×
                    </span>
                  )}
                </div>
              );
            }}
            disabled={props?.disabled}
            readOnly={props?.readOnly}
            loading={props?.isLoading}
            defaultValue={props.defaultValue}
            filterOption={props?.filterOption}
            optionFilterProp={props?.optionFilterProp}
            size={props?.size}
            options={props?.options}
            onSelect={props?.onSelect}
            onInputKeyDown={props?.onInputKeyDown}
            onKeyDown={props?.onKeyDown}
            onKeyUp={props?.onKeyUp}
            onClear={props?.onClear}
            getPopupContainer={props?.getPopupContainer}
            removeIcon={props?.removeIcon}
            autoClearSearchValue={props?.autoClearSearchValue}
            placeholder={props.placeholder}
            ref={props?.ref}
            autoFocus={props.autofocus}
            onFocus={onFocus}
            clearIcon={
              <CloseCircleFilled
                style={{ fontSize: "14px", color: "rebeccapurple" }}
              />
            }
            dropdownClassName={`nastaliq-dropdown ${props.dropdownClassName || ""}`}
          >
            {selectOptions}
          </Select>
        </div>
      )}

      {type == "datePicker" && (
        <DatePicker
          onChange={(e) => props.onChange(e)}
          value={value}
          disabledDate={disabledDate}
          disabled={disabled}
          format={format || "DD-MM-YYYY"}
          style={{ width: "100%" }}
          inputReadOnly={true}
          placeholder={placeholder}
          defaultValue={props.defaultValue}
        />
      )}

      {type == "yearPicker" && (
        <DatePicker
          onChange={(e) => props.onChange(e)}
          value={value}
          disabledDate={disabledDate}
          disabled={disabled}
          style={{ width: "100%" }}
          inputReadOnly={true}
          placeholder={""}
          defaultValue={props.defaultValue}
          picker="year"
        />
      )}

      {type == "timePicker" && (
        <TimePicker
          onChange={(e) => props.onChange(e)}
          value={value}
          disabledDate={disabledDate}
          disabled={disabled}
          use12Hours
          format={format}
          style={{ width: "100%" }}
          placeholder={""}
          inputReadOnly={true}
          defaultValue={props.defaultValue}
          minuteStep={props.minuteStep}
        />
      )}

      {type == "autoComplete" && (
        <AutoComplete
          dataSource={options}
          value={value}
          allowClear
          placeholder={placeholder}
          popupClassName={props.popupClassName}
          dropdownClassName={props.dropdownClassName}
          onChange={(value) => props.onChange(value)}
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={props.onSelect}
          maxLength={maxLength}
        />
      )}

      {type == "textArea" && (
        <TextArea
          onChange={props.onChange}
          name={name}
          style={urduFontStyle}
          rows={rows}
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          placeholder={placeholder}
          showCount={props.showCount}
          autoSize={props.autoSize}
          allowClear={allowClear}
          onPressEnter={props.onPressEnter}
          onKeyDown={onKeyDown}
          onKeyUp={onKeyUp}
          onFocus={onFocus}
          autoFocus={autofocus}
          dir={props?.dir}
          id={props.id}
        />
      )}

      {type == "timePickerRange" && (
        <CustomTimeRangePicker
          value={value}
          onChange={(val) => props.onChange(val)}
          disabled={disabled}
          placeholder={props.placeholder || ["Start Time", "End Time"]}
          label={label}
          required={required}
          error={props.error}
        />
      )}

      <label className={labelClass} id={props.labelId} style={props.labelStyle}>
        {label} {requiredMark}
      </label>
    </div>
  );
};

export default FloatInput;
